export type Maybe<T> = T | null;

export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

/** User's access level for an operations. */
export enum AccessLevel {
  /** Can edit, but some fields are restricted. */
  Contributor = 'Contributor',
  LimitedViewer = 'LimitedViewer',
  /** Can edit everything. */
  Manager = 'Manager',
  NoPermission = 'NoPermission',
  Viewer = 'Viewer',
}

export type GetAccessLevelsQuery = {
  data: Array<{
    target: string;
    level: AccessLevel;
    arguments?:
      | {
          targetTermYear?: string | null | undefined;
          type?: string | null | undefined;
        }
      | null
      | undefined;
  }>;
};

export type AccessLevelsArguments = {
  targetDistrictId?: Maybe<Scalars['String']>;
  targetTermYear?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type GetAccessLevelsResults = {
  arguments?: Maybe<AccessLevelsArguments>;
  level: AccessLevel;
  target: Scalars['String'];
};

export type ConferencesAccessLvl = {
  id: string;
  level: AccessLevel;
  targetTermYear: string;
};

export type Country = {
  id: string;
  shortCode: string;
  countryName: string;
  RequireState: boolean;
};

export type TimeZone = {
  id: string;
  value: string;
  timeZoneName: string;
  location: string;
  offset: string;
};

export type InputAccomodationPhone = {
  countryId: Scalars['String'];
  extension?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  phoneType: Scalars['String'];
};

export type ParticipatingDistrictsInput = {
  id: Scalars['String'];
  riDistrictId: Scalars['Int'];
};

export type InputConferenceAddress = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  internationalProvince?: Maybe<Scalars['String']>;
  lineOne?: Maybe<Scalars['String']>;
  lineThree?: Maybe<Scalars['String']>;
  lineTwo?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type ParticipantDistrictType = {
  id?: Maybe<Scalars['String']>;
  districtId?: Maybe<Scalars['String']>;
  nfKey?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
};

export type InputCreateConference = {
  districtId: Scalars['String'];
  nfKey: Scalars['String'];
  startDate?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  rotaryYear?: Maybe<Scalars['String']>;
  venueName?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  prAccommodation?: Maybe<Scalars['String']>;
  locationCityState?: Maybe<Scalars['String']>;
  locationCountry?: Maybe<Scalars['String']>;
  locationNameEng?: Maybe<Scalars['String']>;
  locationCityStateEng?: Maybe<Scalars['String']>;
  presRepresentativeHotel?: Maybe<Scalars['String']>;
  presRepresentativeHotelAddress?: Maybe<Scalars['String']>;
  presRespresntativeHotelPhone?: Maybe<Scalars['String']>;
  prComment?: Maybe<Scalars['String']>;
  govComment?: Maybe<Scalars['String']>;
  venueType: Scalars['String'];
  onlineLocation?: Maybe<Scalars['String']>;
  locationNameOrDetail?: Maybe<Scalars['String']>;
  detailForJoiningRemotely?: Maybe<Scalars['String']>;
  conferenceAddress?: Maybe<InputConferenceAddress>;
  prAddress?: Maybe<InputConferenceAddress>;
  timeZone?: Maybe<Scalars['String']>;
  isPresRepRequested?: Maybe<Scalars['Boolean']>;
  presRepAccPhone?: Maybe<InputAccomodationPhone>;
  participatingDistrict?: Maybe<ParticipantDistrictType>;
  presidentialRepresentativeId?: Maybe<Scalars['String']>;
  participatingDistricts?: Maybe<Array<ParticipatingDistrictsInput>>;
};

export enum PhoneType {
  Business = 'Business',
  Home = 'Home',
  Mobile = 'Mobile',
}

export enum MeetingType {
  Hybrid = 'Hybrid',
  Online = 'Online',
  Physical = 'Physical',
}

export type ConferenceAddress = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  internationalProvince?: Maybe<Scalars['String']>;
  lineOne?: Maybe<Scalars['String']>;
  lineThree?: Maybe<Scalars['String']>;
  lineTwo?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type ParticipatingDistricts = {
  id: Scalars['String'];
  riDistrictId: Scalars['Int'];
};

export type AccPhone = {
  countryId?: Maybe<Scalars['String']>;
  extension?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  phoneType: Scalars['String'];
};

export type GetConferenceDetailsResult = {
  id?: Maybe<Scalars['String']>;
  districtId?: Maybe<Scalars['String']>;
  createdByRiDistrictId?: Maybe<Scalars['String']>;
  nfKey?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  relatedRotaryYear: Scalars['String'];
  venueName?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  prAccommodation?: Maybe<Scalars['String']>;
  locationCityState?: Maybe<Scalars['String']>;
  locationCountry?: Maybe<Scalars['String']>;
  locationNameEng?: Maybe<Scalars['String']>;
  locationCityStateEng?: Maybe<Scalars['String']>;
  presRepresentativeHotel?: Maybe<Scalars['String']>;
  presRepresentativeHotelAddress?: Maybe<Scalars['String']>;
  presRespresntativeHotelPhone?: Maybe<Scalars['String']>;
  prComment?: Maybe<Scalars['String']>;
  govComment?: Maybe<Scalars['String']>;
  venueType: MeetingType;
  onlineLocation?: Maybe<Scalars['String']>;
  locationNameOrDetail?: Maybe<Scalars['String']>;
  detailForJoiningRemotely?: Maybe<Scalars['String']>;
  conferenceAddress?: Maybe<ConferenceAddress>;
  prAddress?: Maybe<ConferenceAddress>;
  timeZone?: Maybe<Scalars['String']>;
  isPresRepRequested?: Maybe<Scalars['Boolean']>;
  presRepAccPhone?: Maybe<AccPhone>;
  presidentialRepresentative?: Maybe<Scalars['String']>;
  participatingDistricts?: Maybe<Array<ParticipatingDistricts>>;
};

export type FormattedLocation = {
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  internationalProvince?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type PresidentialRepresentativeType = {
  firstName?: string | null;
  id?: string | null;
  lastName?: string | null;
  middleName?: string | null;
};

export type FetchConferenceQuery = {
  id?: Maybe<Scalars['String']>;
  districtId?: Maybe<Scalars['String']>;
  createdByRiDistrictId?: Maybe<Scalars['String']>;
  nfKey?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  startTime?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  relatedRotaryYear: Scalars['String'];
  venueName?: Maybe<Scalars['String']>;
  language?: Maybe<Scalars['String']>;
  prAccommodation?: Maybe<Scalars['String']>;
  locationCityState?: Maybe<Scalars['String']>;
  locationCountry?: Maybe<Scalars['String']>;
  locationNameEng?: Maybe<Scalars['String']>;
  locationCityStateEng?: Maybe<Scalars['String']>;
  presRepresentativeHotel?: Maybe<Scalars['String']>;
  presRepresentativeHotelAddress?: Maybe<Scalars['String']>;
  presRespresntativeHotelPhone?: Maybe<Scalars['String']>;
  prComment?: Maybe<Scalars['String']>;
  govComment?: Maybe<Scalars['String']>;
  venueType: MeetingType;
  onlineLocation?: Maybe<Scalars['String']>;
  locationNameOrDetail?: Maybe<Scalars['String']>;
  detailForJoiningRemotely?: Maybe<Scalars['String']>;
  conferenceAddress?: Maybe<ConferenceAddress>;
  prAddress?: Maybe<ConferenceAddress>;
  timeZone?: Maybe<Scalars['String']>;
  isPresRepRequested?: Maybe<Scalars['Boolean']>;
  presRepAccPhone?: Maybe<AccPhone>;
  presidentialRepresentative?: string | null | undefined;
  participatingDistricts?: Maybe<Array<ParticipatingDistricts>>;
};
